import {
  CREATE_SERVICE,
  CREATE_SERVICE_FAILURE,
  CREATE_SERVICE_SUCCESS,
  DELETE_SERVICE,
  DELETE_SERVICE_FAILURE,
  DELETE_SERVICE_SUCCESS,
  GET_SERVICES,
  GET_SERVICES_FAILURE,
  GET_SERVICES_SUCCESS,
  GET_SINGLE_SERVICE,
  GET_SINGLE_SERVICE_FAILURE,
  GET_SINGLE_SERVICE_SUCCESS,
  UPDATE_SERVICE,
  UPDATE_SERVICE_FAILURE,
  UPDATE_SERVICE_SUCCESS,
} from "./actionTypes";

const initialState = {
  services: [],
  singleService: {},
  isLoggedIn: null,
  loading: false,
  error: "",
};

const services = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVICES:
      return {
        ...state,
        loading: true,
      };

    case GET_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload,
        loading: false,
      };

    case GET_SERVICES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case GET_SINGLE_SERVICE:
      return {
        ...state,
        loading: true,
      };

    case GET_SINGLE_SERVICE_SUCCESS:
      return {
        ...state,
        singleService: action.payload,
        loading: false,
      };

    case GET_SINGLE_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case CREATE_SERVICE:
      return {
        ...state,
        loading: true,
      };

    case CREATE_SERVICE_SUCCESS:
      return {
        ...state,
        services: [...state.services, action.payload],
        loading: false,
      };

    case CREATE_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case UPDATE_SERVICE:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_SERVICE_SUCCESS:
      return {
        ...state,
        services: state.services.map((service) =>
          service._id === action.payload?.id ? action.payload : service
        ),
        loading: false,
      };

    case UPDATE_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case DELETE_SERVICE:
      return {
        ...state,
        loading: true,
      };

    case DELETE_SERVICE_SUCCESS:
      return {
        ...state,
        services: state.services.filter(
          (service) => service._id !== action.payload?.id
        ),
        loading: false,
      };

    case DELETE_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default services;
